import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {fetchPaymentUsers, deletePaymentUser, updatePaymentUser, createPaymentUser } from "../services/paymentService";
import { setFilters } from "./matchFilterSlice";

// Async thunks
export const fetchPaymentUsersAsync = createAsyncThunk(
  "paymentUsers/fetchPaymentUsers",
  async () => {
    const response = await fetchPaymentUsers();
    return response;
  }
);

export const createPaymentUserAsync = createAsyncThunk(
  "paymentUsers/createPaymentUser",
  async (paymentUserData) => {
    const response = await createPaymentUser(paymentUserData);
    return response;
  }
);

export const deletePaymentUserAsync = createAsyncThunk(
  "paymentUsers/deletePaymentUser",
  async (id) => {
    const response = await deletePaymentUser(id);
    return response;
  }
);

export const updatePaymentUserAsync = createAsyncThunk(
  "paymentUsers/updatePaymentUser",
  async ({ id, paymentUserData }) => {
    const response = await updatePaymentUser(id, paymentUserData);
    return response;
  }
);

const paymentUsersSlice = createSlice({
  name: "paymentUsers",
  initialState: {
    users: [],
    loading: false,
    error: null,
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPaymentUsersAsync.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchPaymentUsersAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.users = action.payload?.users || [];
        })
        .addCase(fetchPaymentUsersAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        // Handle createPaymentUserAsync cases
        builder.addCase(createPaymentUserAsync.pending, (state) => {
            state.loading = true;
        })
        .addCase(createPaymentUserAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.users.push(action.payload);
        })
        .addCase(createPaymentUserAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        // Handle deletePaymentUserAsync cases
        builder.addCase(deletePaymentUserAsync.pending, (state) => {
            state.loading = true;
        })
        .addCase(deletePaymentUserAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.users = state.users.filter(user => user.id !== action.payload.id);
        })
        .addCase(deletePaymentUserAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        // Handle updatePaymentUserAsync cases
        builder.addCase(updatePaymentUserAsync.pending, (state) => {
            state.loading = true;
        })
        .addCase(updatePaymentUserAsync.fulfilled, (state, action) => {
            state.loading = false;
            const index = state.users.findIndex(user => user.id === action.payload.id);
            if (index !== -1) {
                state.users[index] = action.payload;
            }
        })
        .addCase(updatePaymentUserAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }});

export const {paymentUsers} = paymentUsersSlice.actions;
export default paymentUsersSlice.reducer;